'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import UCElement1 from '@/components/UCElement1';
import FAQSection from '@/components/FAQSection';
import { universalCylinderFaqs } from '@/data/faqData';

const UniversalCylinderPage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Cone & Cylinder Filters' }]} />
        <div className="container-0">
          <UCElement1 />
          <FAQSection faqs={universalCylinderFaqs} title="FAQs About Cone and Cylinder Air Filters" boldAnswer />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default UniversalCylinderPage;
